/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { HEADER_HEIGHT_PX } from 'bundles/authentication-common/constants';
import CourseraLogo from 'bundles/page/components/CourseraLogo';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

type Props = {
  logoAsLink?: boolean;
  linkTrackingName?: string;
};

const styles = {
  container: css`
    align-items: center;
    background-color: var(--cds-color-neutral-background-primary);
    box-shadow: 0 2px 2px rgb(0 0 0 / 10%);
    display: flex;
    height: ${HEADER_HEIGHT_PX}px;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1;

    @media (min-width: 600px) {
      display: none !important;
    }
  `,
  logo: css`
    width: 108px;
  `,
  logoLink: css`
    display: flex;
    align-items: center;
  `,
};

const Header = ({ logoAsLink, linkTrackingName }: Props) => (
  <header css={styles.container}>
    {logoAsLink ? (
      <TrackedA css={styles.logoLink} href="/" trackingName={linkTrackingName || 'auth_modal_logo'}>
        <CourseraLogo css={styles.logo} />
      </TrackedA>
    ) : (
      <CourseraLogo css={styles.logo} />
    )}
  </header>
);

export default Header;
